module.exports = __webpack_public_path__ + "static/media/navy-blue-add-driver-btn.146c278a.svg";